import React from "react";
import "./HrdTime.css";
const HrdTime = () => {
  return (
    <div className="hrdTimeContainer">
      <h2>Total time to get Attestation from HRD:</h2>
      <p>
        The overall time depends on various factors such as the state from which
        you applied for it, the kinds of documents you need to get attested &
        the type of university verification necessitated. Generally, it takes
        2-3 Working Days but it may extend up to a couple of weeks more than a
        month. We provide you best quality services & will complete the entire
        procedure of VTU HRD attestation in Bangalore with genuinity.
      </p>
    </div>
  );
};

export default HrdTime;
